<template>
    <SupervisorManagement></SupervisorManagement>
</template>
<script>
    import SupervisorManagement from '@/components/SupervisorManagement.vue'
    export default {
        name: 'supervisor-management',
        components: {
            SupervisorManagement
        }
    }
</script>